export const DEFAULT_TERMS = [
  { id: 1, label: 'Windows', term: '1/3 down, balance on completion' },
  { id: 2, label: 'Doors',   term: '1/2 down, balance on completion' },
  { id: 3, label: 'Balance', term: 'Due on completion of installation' },
];

export default function PaymentTerms({ terms, onChange }) {
  function updateTerm(id, value) {
    onChange(terms.map(t => t.id === id ? { ...t, term: value } : t));
  }

  return (
    <div style={{ background: 'white', borderRadius: '12px', border: '1px solid rgba(139,69,19,0.1)', boxShadow: '0 4px 16px rgba(139,69,19,0.07)', overflow: 'hidden', marginTop: '20px' }}>
      <div style={{ padding: '10px 16px', background: 'linear-gradient(135deg, #8B4513 0%, #A0522D 100%)', display: 'flex', alignItems: 'center', gap: '8px' }}>
        <span style={{ fontSize: '14px' }}>📋</span>
        <span style={{ color: 'white', fontWeight: '700', fontSize: '13px' }}>Payment Terms</span>
        <span style={{ marginLeft: 'auto', fontSize: '10px', color: 'rgba(255,255,255,0.7)', fontStyle: 'italic' }}>Pre-filled — editable</span>
      </div>
      <div style={{ padding: '12px 16px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
        {terms.map(t => (
          <div key={t.id} style={{ display: 'grid', gridTemplateColumns: '80px 1fr', gap: '10px', alignItems: 'center' }}>
            <span style={{ fontSize: '11px', fontWeight: '700', color: '#8B4513', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
              {t.label}:
            </span>
            <input type="text" value={t.term} onChange={e => updateTerm(t.id, e.target.value)}
              style={{ border: '1px solid rgba(139,69,19,0.12)', borderRadius: '6px', padding: '5px 10px', fontSize: '12px', color: '#2b2b2b', fontFamily: 'inherit', outline: 'none', background: '#fdfcfb' }} />
          </div>
        ))}
      </div>
    </div>
  );
}
